export default __webpack_public_path__ + "static/media/logo-us-adidas.fdfd1138.svg";